<template>
  <q-card class="albums-card">
    <q-toolbar class="text-pink-6">
      <q-toolbar-title>
        <router-link :to="`/clients/${clientId}/albums`" class="link text-pink-6">
          Digital Albums
        </router-link>
      </q-toolbar-title>
      <q-icon name="fa fa-address-book" size="sm" />
    </q-toolbar>
    <q-separator />
    <q-card-section>
      <loader :task="task" />
      <div v-show="numAlbums !== null" class="row">
        <div class="col-6">
          <span class="text-h3 text-bold">{{ numAlbums }}</span>
          Album<span v-show="numAlbums !== 1">s</span>
        </div>
        <div class="col-6 text-right" style="align-self: flex-end">
          <q-btn
            label="View Albums"
            :to="`/clients/${clientId}/albums`"
            flat
            rounded
          />
        </div>
      </div>
    </q-card-section>
  </q-card>
</template>

<style lang="scss">
@import '../../styles/quasar.variables';

.albums-card {
  border-bottom: 3px solid $pink-6;
}
</style>

<script lang="ts">
import { defineComponent } from 'vue';
import Loader from '@/components/loading/AsyncLinearProgress.vue';
import reportRepository from '@/report/report-repository';
import { types as reportTypes } from '@/report';
import { ReportFilters } from '@/type';

interface Data {
  filters: ReportFilters,
  task: Promise<number>|null,
  numAlbums: number|null,
}

export default defineComponent({
  components: { Loader },
  props: {
    clientId: {
      type: Number,
      required: true,
    },
  },
  data(): Data {
    return {
      filters: {
        types: [reportTypes.ALBUM],
      },
      task: null,
      numAlbums: null,
    };
  },
  watch: {
    clientId: {
      handler() {
        this.load();
      },
      immediate: true,
    },
  },
  methods: {
    async load() {
      this.task = reportRepository.count(this.clientId, this.filters);
      this.numAlbums = await this.task;
    },
  },
});
</script>
